<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Multifunktionsskrivarna MB3442, MX331, MX431, XM1342">
     Multifunktionsskrivarna MB3442, MX331, MX431, XM1342
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sv" title="S&auml;kerhetsinformation">
     S&auml;kerhetsinformation
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Skrivs&auml;tt">
      Skrivs&auml;tt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="Information om produkten">
      Information om produkten
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sv" title="L&auml;r dig mer om skrivaren">
     L&auml;r dig mer om skrivaren
    </a>
   </p>
   <div id="divd0e177">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sv" title="Hitta information om skrivaren">
      Hitta information om skrivaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_sv" title="Hitta skrivarserienumret">
      Hitta skrivarserienumret
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-model-topic.html#configured-model_sv" title="Skrivarkonfiguration">
      Skrivarkonfiguration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sv" title="Anv&auml;nda kontrollpanelen">
      Anv&auml;nda kontrollpanelen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sv" title="Anpassa startsk&auml;rmen">
      Anpassa startsk&auml;rmen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-keyboard-on-display-topic.html#changing-language-of-keyboard-on-display_sv" title="&Auml;ndra spr&aring;k f&ouml;r sk&auml;rmens tangentbord">
      &Auml;ndra spr&aring;k f&ouml;r sk&auml;rmens tangentbord
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sv" title="S&aring; h&auml;r anv&auml;nds indikatorlampan">
      S&aring; h&auml;r anv&auml;nds indikatorlampan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e557" title="V&auml;lja papper">
      V&auml;lja papper
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sv" title="Installera och konfigurera">
     Installera och konfigurera
    </a>
   </p>
   <div id="divd0e1449">
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_sv" title="V&auml;lja en plats f&ouml;r skrivaren">
      V&auml;lja en plats f&ouml;r skrivaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sv" title="Ansluta kablar">
      Ansluta kablar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_sv" title="Installera tillvalsmagasin">
      Installera tillvalsmagasin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1678" title="St&auml;lla in skrivaren f&ouml;r att faxa">
      St&auml;lla in skrivaren f&ouml;r att faxa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_sv" title="Konfigurera SMTP-inst&auml;llningarna f&ouml;r e-post">
      Konfigurera SMTP-inst&auml;llningarna f&ouml;r e-post
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e3662" title="Fylla p&aring; papper och specialmedia">
      Fylla p&aring; papper och specialmedia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3826" title="Installera och uppdatera program, drivrutiner och fast programvara">
      Installera och uppdatera program, drivrutiner och fast programvara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e4109" title="N&auml;tverk">
      N&auml;tverk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_sv" title="Skapa en Cloud Connector-profil">
      Skapa en Cloud Connector-profil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sv" title="Skriva ut en sida med menyinst&auml;llningar">
      Skriva ut en sida med menyinst&auml;llningar
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sv" title="S&auml;kra skrivaren">
     S&auml;kra skrivaren
    </a>
   </p>
   <div id="divd0e4547">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sv" title="Lokalisera s&auml;kerhetsplats">
      Lokalisera s&auml;kerhetsplats
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sv" title="Radera skrivarminnet">
      Radera skrivarminnet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sv" title="&Aring;terst&auml;lla fabriksinst&auml;llningar">
      &Aring;terst&auml;lla fabriksinst&auml;llningar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_sv" title="Flyktighetsredog&ouml;relse">
      Flyktighetsredog&ouml;relse
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sv" title="Skriv ut">
     Skriv ut
    </a>
   </p>
   <div id="divd0e4682">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sv" title="Skriva ut fr&aring;n en dator">
      Skriva ut fr&aring;n en dator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4708" title="Skriva ut fr&aring;n en mobil enhet">
      Skriva ut fr&aring;n en mobil enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sv" title="Skriva ut fr&aring;n flashenhet">
      Skriva ut fr&aring;n flashenhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_sv" title="Flashenheter och filtyper som st&ouml;ds">
      Flashenheter och filtyper som st&ouml;ds
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sv" title="Konfigurera konfidentiella jobb">
      Konfigurera konfidentiella jobb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sv" title="Skriva ut konfidentiella jobb och andra stoppade jobb">
      Skriva ut konfidentiella jobb och andra stoppade jobb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_sv" title="Skriva ut fr&aring;n en Cloud Connector-profil">
      Skriva ut fr&aring;n en Cloud Connector-profil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_sv" title="Skriva ut en lista med teckensnittsprov">
      Skriva ut en lista med teckensnittsprov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_sv" title="Placera skiljeblad mellan kopior">
      Placera skiljeblad mellan kopior
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sv" title="Avbryta utskriftsjobb">
      Avbryta utskriftsjobb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_sv" title="Justera tonersv&auml;rtan">
      Justera tonersv&auml;rtan
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_sv" title="Kopiera">
     Kopiera
    </a>
   </p>
   <div id="divd0e5293">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_sv" title="Anv&auml;nda den automatiska dokumentmataren och skannerglaset">
      Anv&auml;nda den automatiska dokumentmataren och skannerglaset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_sv" title="G&ouml;ra kopior">
      G&ouml;ra kopior
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_sv" title="Kopiera foton">
      Kopiera foton
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_sv" title="Kopiera till brevpapper">
      Kopiera till brevpapper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_sv" title="Kopiera p&aring; papperets b&aring;da sidor">
      Kopiera p&aring; papperets b&aring;da sidor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_sv" title="F&ouml;rminska eller f&ouml;rstora kopior">
      F&ouml;rminska eller f&ouml;rstora kopior
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_sv" title="Kopiera flera sidor p&aring; ett ark">
      Kopiera flera sidor p&aring; ett ark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_sv" title="Sortera kopior">
      Sortera kopior
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_sv" title="Kopiera kort">
      Kopiera kort
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_sv" title="Skapa en genv&auml;g f&ouml;r kopiering">
      Skapa en genv&auml;g f&ouml;r kopiering
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_sv" title="E-post">
     E-post
    </a>
   </p>
   <div id="divd0e5579">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_sv" title="Anv&auml;nda den automatiska dokumentmataren och skannerglaset">
      Anv&auml;nda den automatiska dokumentmataren och skannerglaset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_sv" title="Skicka ett e-postmeddelande">
      Skicka ett e-postmeddelande
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_sv" title="Skapa en e-postgenv&auml;g">
      Skapa en e-postgenv&auml;g
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_sv" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e5697">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_sv" title="Anv&auml;nda den automatiska dokumentmataren och skannerglaset">
      Anv&auml;nda den automatiska dokumentmataren och skannerglaset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_sv" title="Skicka ett fax">
      Skicka ett fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_sv" title="Schemal&auml;gga ett fax">
      Schemal&auml;gga ett fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_sv" title="Skapa en faxdestinationsgenv&auml;g">
      Skapa en faxdestinationsgenv&auml;g
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_sv" title="&Auml;ndra faxuppl&ouml;sning">
      &Auml;ndra faxuppl&ouml;sning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_sv" title="Justera sv&auml;rtan f&ouml;r faxmeddelanden">
      Justera sv&auml;rtan f&ouml;r faxmeddelanden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_sv" title="Skriv ut en faxlogg">
      Skriv ut en faxlogg
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_sv" title="Blockera skr&auml;pfax">
      Blockera skr&auml;pfax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_sv" title="Stoppa fax">
      Stoppa fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_sv" title="Vidarebefordra ett fax">
      Vidarebefordra ett fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_sv" title="Skanna">
     Skanna
    </a>
   </p>
   <div id="divd0e6077">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_sv" title="Anv&auml;nda den automatiska dokumentmataren och skannerglaset">
      Anv&auml;nda den automatiska dokumentmataren och skannerglaset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_sv" title="Skanna till en dator">
      Skanna till en dator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_sv" title="Skanna till en FTP-server med hj&auml;lp av en genv&auml;g">
      Skanna till en FTP-server med hj&auml;lp av en genv&auml;g
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_sv" title="Skanna till en n&auml;tverksmapp med hj&auml;lp av en genv&auml;g">
      Skanna till en n&auml;tverksmapp med hj&auml;lp av en genv&auml;g
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_sv" title="Skanna till en flashenhet">
      Skanna till en flashenhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_sv" title="Skanna till en Cloud Connector-profil">
      Skanna till en Cloud Connector-profil
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sv" title="Anv&auml;nda skrivarens menyer">
     Anv&auml;nda skrivarens menyer
    </a>
   </p>
   <div id="divd0e6409">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_sv" title="Meny&ouml;versikt">
      Meny&ouml;versikt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6728" title="Enhet">
      Enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8359" title="Skriv ut">
      Skriv ut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9204" title="Papper">
      Papper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e9549" title="Kopiera">
      Kopiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e9789" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e11408" title="E-post">
      E-post
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e11978" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e12283" title="USB-enhet">
      USB-enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e12778" title="N&auml;tverk/portar">
      N&auml;tverk/portar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e14734" title="S&auml;kerhet">
      S&auml;kerhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_sv" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e15451" title="Rapporter">
      Rapporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_sv" title="Fels&ouml;kning">
      Fels&ouml;kning
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sv" title="Underh&aring;lla skrivaren">
     Underh&aring;lla skrivaren
    </a>
   </p>
   <div id="divd0e15754">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_sv" title="Kontrollera status f&ouml;r skrivarens delar och f&ouml;rbrukningsmaterial">
      Kontrollera status f&ouml;r skrivarens delar och f&ouml;rbrukningsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_sv" title="Konfigurera meddelanden om f&ouml;rbrukningsmaterial">
      Konfigurera meddelanden om f&ouml;rbrukningsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sv" title="St&auml;lla in e-postaviseringar">
      St&auml;lla in e-postaviseringar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_sv" title="Visa rapporter">
      Visa rapporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sv" title="Best&auml;lla delar och f&ouml;rbrukningsmaterial">
      Best&auml;lla delar och f&ouml;rbrukningsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e16196" title="Byta ut delar och f&ouml;rbrukningsartiklar">
      Byta ut delar och f&ouml;rbrukningsartiklar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e16423" title="Reng&ouml;ra skrivarens delar">
      Reng&ouml;ra skrivarens delar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e16566" title="Spara energi och papper">
      Spara energi och papper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_sv" title="Flytta skrivaren till en annan plats">
      Flytta skrivaren till en annan plats
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_sv" title="Skicka skrivaren">
      Skicka skrivaren
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sv" title="Fels&ouml;ka problem">
     Fels&ouml;ka problem
    </a>
   </p>
   <div id="divd0e16723">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_sv" title="Problem med utskriftskvalitet">
      Problem med utskriftskvalitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sv" title="Utskriftsproblem">
      Utskriftsproblem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_sv" title="Skrivaren svarar inte">
      Skrivaren svarar inte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_sv" title="Det g&aring;r inte att l&auml;sa flashenheten">
      Det g&aring;r inte att l&auml;sa flashenheten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_sv" title="Aktivera USB-porten">
      Aktivera USB-porten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e19414" title="Problem med n&auml;tverksanslutningen">
      Problem med n&auml;tverksanslutningen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e19626" title="Problem med f&ouml;rbrukningsmaterial">
      Problem med f&ouml;rbrukningsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_sv" title="&Aring;tg&auml;rda pappersstopp">
      &Aring;tg&auml;rda pappersstopp
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e20155" title="Pappersmatningsproblem">
      Pappersmatningsproblem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e20522" title="E-postproblem">
      E-postproblem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e20618" title="Faxproblem">
      Faxproblem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e21256" title="Skanningsproblem">
      Skanningsproblem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sv" title="Kontakta kundsupport">
      Kontakta kundsupport
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_sv" title="&Aring;tervinning och kassering">
     &Aring;tervinning och kassering
    </a>
   </p>
   <div id="divd0e22056">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_sv" title="&Aring;tervinna produkter fr&aring;n Lexmark">
      &Aring;tervinna produkter fr&aring;n Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_sv" title="&Aring;tervinna f&ouml;rpackningar fr&aring;n Lexmark">
      &Aring;tervinna f&ouml;rpackningar fr&aring;n Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sv" title="Meddelanden">
     Meddelanden
    </a>
   </p>
   <div id="divd0e22091">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22094" title="Produktinformation">
      Produktinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22111" title="Om utg&aring;van">
      Om utg&aring;van
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sv" title="Varum&auml;rken">
      Varum&auml;rken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sv" title="Licensinformation">
      Licensinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sv" title="Bullerni&aring;ver">
      Bullerni&aring;ver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sv" title="WEEE-direktivet (Waste from Electrical and Electronic Equipment)">
      WEEE-direktivet (Waste from Electrical and Electronic Equipment)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22216" title="Laddningsbart litiumjonbatteri">
      Laddningsbart litiumjonbatteri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sv" title="F&ouml;rordning (EU) 2023/1542">
      F&ouml;rordning (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22254" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sv" title="Produktkassering">
      Produktkassering
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive_sv" title="EU:s batteridirektiv">
      EU:s batteridirektiv
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sv" title="L&auml;mna tillbaka Lexmark-kassetter f&ouml;r &aring;teranv&auml;ndning eller &aring;tervinning">
      L&auml;mna tillbaka Lexmark-kassetter f&ouml;r &aring;teranv&auml;ndning eller &aring;tervinning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sv" title="Meddelande om statisk elektricitet">
      Meddelande om statisk elektricitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sv" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sv" title="Temperaturinformation">
      Temperaturinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sv" title="Meddelande om laser">
      Meddelande om laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sv" title="Str&ouml;mf&ouml;rbrukning">
      Str&ouml;mf&ouml;rbrukning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_sv" title="Meddelanden om riktlinjer f&ouml;r terminalutrustning f&ouml;r telekommunikation">
      Meddelanden om riktlinjer f&ouml;r terminalutrustning f&ouml;r telekommunikation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22518" title="Information om regler f&ouml;r tr&aring;dl&ouml;sa produkter">
      Information om regler f&ouml;r tr&aring;dl&ouml;sa produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sv" title="Information om modul&auml;ra komponenter">
      Information om modul&auml;ra komponenter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sv" title="Exponering f&ouml;r RF-str&aring;lning">
      Exponering f&ouml;r RF-str&aring;lning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22543" title="EU-regler">
      EU-regler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_sv" title="EU-regler">
      EU-regler
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue